export class TenancyAcceptancePost {
    accept: boolean;
}
